import { lazy } from 'react';

export type RouteProps = {
  path: string;
  element: React.LazyExoticComponent<React.ComponentType<any>>;
};

export type RoutesKeys = 'HOME' | 'AUTH' | 'SOCIAL_ORGANIZATION' | 'PROVIDER';

export type RoutesProps = {
  [key in RoutesKeys]: RouteProps[];
};

export const RoutesMap: RoutesProps = {
  HOME: [
    {
      path: '/',
      element: lazy(() => import('../pages/Home/Home.view')),
    },
    {
      path: '/conheca-mais',
      element: lazy(() => import('../pages/Home/FAQ/FAQ.view')),
    },
  ],
  AUTH: [
    {
      path: '/registros',
      element: lazy(() => import('../pages/Register/Register.view')),
    },
  ],
  SOCIAL_ORGANIZATION: [
    {
      path: '/painel',
      element: lazy(() => import('../pages/Panel/SocialOrganization/SocialOrganization.view')),
    },
    {
      path: '/painel/nova-iniciativa',
      element: lazy(
        () => import('../pages/Panel/SocialOrganization/UpsertInitiative/UpsertInitiative.view')
      ),
    },
    {
      path: '/painel/iniciativa/:initiativeId',
      element: lazy(() => import('../pages/Panel/SocialOrganization/Initiative/Initiative.view')),
    },
    {
      path: '/painel/iniciativa/:initiativeId/editar',
      element: lazy(
        () => import('../pages/Panel/SocialOrganization/UpsertInitiative/UpsertInitiative.view')
      ),
    },
    {
      path: '/painel/ambiente-de-aprendizado',
      element: lazy(
        () => import('../pages/Panel/SocialOrganization/SupportMaterials/SupportMaterials.view')
      ),
    },
  ],
  PROVIDER: [
    {
      path: '/painel',
      element: lazy(() => import('../pages/Panel/Provider/Provider.view')),
    },
    {
      path: '/painel/iniciativa/:initiativeId',
      element: lazy(() => import('../pages/Panel/Provider/Initiative/Initiative.view')),
    },
    {
      path: '/painel/iniciativas-acompanhadas',
      element: lazy(
        () => import('../pages/Panel/Provider/SupportInterested/SupportInterested.view')
      ),
    },
    {
      path: '/painel/iniciativas-apoiadas',
      element: lazy(() => import('../pages/Panel/Provider/SupportConfirmed/SupportConfirmed.view')),
    },
    {
      path: '/painel/ambiente-de-aprendizado',
      element: lazy(() => import('../pages/Panel/Provider/SupportMaterials/SupportMaterials.view')),
    },
  ],
};
